import { TicketManager } from '../../managers/ticket.manager';
import { Subscription } from 'rxjs';
import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { DialogComponent, DialogService } from '../../services/modal-dialogs';
import { Title } from '@angular/platform-browser';
import { MemberDashboard } from '../../models/ss-api/responses/member.dashboard.response';
import { TemplatesAndFromResponse } from '../../models/ss-api/responses/templates.and.from.response';
import { GlobalService } from '../../services/global.service';
import { ssApiService } from '../../services/ss-api.service';
import { SweetAlertService } from 'ng2-cli-sweetalert2';
import { AddCustomTicketRequest } from '../../models/ss-api/requests/add.custom.ticket.request';
import { TicketStatusTypes, TicketUrgencyTypes } from '../../models/domain/custom.ticket.item';
import { SelectItem } from 'primeng/primeng';
import { AdminHistoryService } from '../../services/admin.history.service';

import 'jquery-slimscroll';
import { TemplateSelectionComponent } from '../../shared/components/template.selection/template.selection.component';
import { Router } from '@angular/router';
import { CKEditorComponent } from 'ng2-ckeditor';
import { AdminPermissionTypes } from '../../models/domain/admin.permission.item';

import { SortBot } from '../../helpers/sort';
import { AdminItemArray } from '../../models/domain/admin.item';



export interface ITicketAddDialogModel {
  TicketMemberID?: number;
  SelectedMemberID?: number;
  MemberOptions: SelectItem[];
}


interface checkBoxOption {
  Label: string;
  LabelHTML: string;
  Value: number;

}

@Component({
  selector: 'ticket-add-dialog',
  templateUrl: './ticket.add.dialog.html',
  styleUrls: ['./ticket.add.dialog.css'],
})

export class TicketAddDialog extends DialogComponent<ITicketAddDialogModel, boolean> implements ITicketAddDialogModel, OnDestroy, OnInit {

  @ViewChild(TemplateSelectionComponent) TemplatePanel: TemplateSelectionComponent;
  @ViewChild('CKEDITOR') CKEDITOR: CKEditorComponent;

  ticketManager: TicketManager;

  // gb : GlobalService;

  TicketMemberID: number;
  CanSelectMember: boolean = true;

  IsBusy: Boolean = false;

  // browser Title
  private originalTitle: string;
  // subscriptions
  private ticketOnMemberAssign: Subscription;
  private ticketOnMemberUnassign: Subscription;


  assignToMember: boolean = false;

  Subject: string = '';
  Body: string = '';

  DueDate: Date = new Date();
  IsInternal: boolean = true;

  Status: TicketStatusTypes = TicketStatusTypes.New;

  SendEmail: boolean = true;


  // FORM ELEMENTS
  UserOptions: SelectItem[];
  SelectedUser: number;

  status: SelectItem[];
  selectedStatus: number;

  StatusOptions: SelectItem[];

  UrgencyOptions: SelectItem[];
  SelectedUrgency: number;

  // EMAIL TEMPLATE STUFF
  MemberData: MemberDashboard = new MemberDashboard();
  TemplatesAndFrom: TemplatesAndFromResponse = new TemplatesAndFromResponse();
  emailTemplate: string = '';
  emailTemplatePanel: boolean = false;

  MemberOptions: SelectItem[];
  SelectedMemberID: number = 0;
  notificationEmail: string;


  // CKEditor Config
  /*
  private CKEditorConfig = {
    allowedContent: true,
    height: 'calc(100% - 104px)',
    resize_enabled: false,
  }
  */


  // CKEditor Config
  private CKEditorConfig = {
    allowedContent: true,
    resize_enabled: false,
    height: '100%',
    toolbarLocation: 'bottom'
  }

  constructor(dialogService: DialogService,
    private titleService: Title,
    private changeDetect: ChangeDetectorRef,
    private gb: GlobalService,
    private api: ssApiService,
    private sweetAlertService: SweetAlertService,
    public historyService: AdminHistoryService,
    private cdRef: ChangeDetectorRef,
    public router: Router) {
    super(dialogService, router);
  }


  ngOnDestroy() {

  }


  ngOnInit() {

    // this.gb = this.Context.GlobalService;

    this.InitUserOptions();
    this.InitStatusOptions();
    this.InitUrgencyOptions();
    this.InitMemberOptions();

  }

  InitMemberOptions() {
    // this.MemberOptions = [];

    // if( this.Context.Data.SelectedMemberID != undefined && this.Context.Data.SelectedMemberID != null )
    //   this.SelectedMemberID = this.Context.Data.SelectedMemberID;

    // if(this.Context.Data.MemberOptions != undefined && this.Context.Data.MemberOptions != null)
    //   this.MemberOptions = this.Context.Data.MemberOptions;

  }

  async GetMemberData() {
    // console.log("GetMemberData Started.", this.Context.Data);
    await this.api.getMemberDashboard( 0 ).toPromise().then( (result) => {
        if (!result.Result) {
          return;
        }
        this.MemberData = result.Data;
      }).catch( (error: any) => { });
  }

  confirm() {

    if (this.CKEDITOR.instance['mode'] != 'wysiwyg') {

        this.CKEDITOR.instance['commands']['source'].exec()
        setTimeout(() => {
            this.confirm();
        }, 500)

        return false;

    }

    let request = new AddCustomTicketRequest();

    request.AdminID = this.SelectedUser;
    request.MemberID = this.SelectedMemberID;
    request.IsInternal = this.IsInternal;
    request.DueDate = this.DueDate;
    request.CreatedByAdmin = true;
    request.FromEmail = this.gb.Email;
    request.Status = this.selectedStatus;
    request.Urgency = this.SelectedUrgency;
    request.Subject = this.Subject;
    request.Body = this.Body;
    request.IsHTMLBody = true;
    request.SendEmail = this.SendEmail;
    request.NotificationEmail =  this.notificationEmail;

    this.sweetAlertService.swal({
      title: 'Create New Ticket?',
      text: 'Are you sure you want to create this new ticket?',
      type: 'warning',
      showCancelButton: true,
      showCloseButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'Cancel',
      allowOutsideClick: false,
      showLoaderOnConfirm: true,
      closeButtonTextContent: 'x',
      preConfirm: () => {
        // addcard
        return this.api.AddCustomTicket(request).toPromise()
      }
    })
      .then(
        async (response) => {

          if (!response.Result) {
            this.sweetAlertService.swal(
              {
                title: 'Error',
                text: 'Error adding Ticket',
                type: 'error',
                showCancelButton: false,
                showConfirmButton: true,
                confirmButtonText: 'Ok',
              })
              .then(() => {
                this.Close();
               }, () => { this.Close(); }); // keep this line to prevent promise error;
            return;
          }


          // show confirmation
          this.sweetAlertService.swal(
            {
              title: 'Success',
              text: 'Ticket was succesfully added',
              type: 'success',
              showCancelButton: false,
              showConfirmButton: false,
              timer: 1500
            })
            .then(() => {
              this.closeOK();
            }, () => { this.closeOK(); }); // keep this line to prevent promise error;


        },
        (dismiss) => {
          if (dismiss === 'cancel') {

            if (!confirm)
              return;

            // show cancelled
            this.sweetAlertService.swal({
              title: 'Cancelled',
              text: 'No changes are saved.',
              type: 'error',
              showCancelButton: false,
              showConfirmButton: false,
              timer: 1000
            }).then(() => {
              this.Close();
            }, () => { }); // keep this line to prevent promise error;
          }
        }).catch(error => {
          this.sweetAlertService.swal(
            {
              title: 'Error',
              text: error.message,
              type: 'error',
              showCancelButton: false,
              showConfirmButton: true,
              confirmButtonText: 'OK',
            })
            .then((response: any) => {

              this.Close();
            }, (dismiss) => {
              // this.IsBusy = false;
              return;
            }); // keep this line to prevent promise error;
        });

  }

  Relation(): string {
    if (this.ticketManager.Ticket().MemberID == -1) {
      return 'Admin Name: ';
    } else if (this.ticketManager.Ticket().MemberID == 0) {
      return 'Lead Name: ';
    } else {
      return 'Member Name: ';
    }
  }

  closeOK() {
    // we set dialog result as true on click on confirm button,
    // then we can get dialog result from caller code
    // this.InvokeEvent(WindowEvent.FromWindowContextResultOK(this.Context, WindowActionTypes.Saved, true));
    this.Close();

  }

  showEmailTemplatePanel() {
    this.emailTemplatePanel = true;
  }


  cancelEmailTemplate() {
    this.emailTemplatePanel = false;
  }

  StatusChanged(e: any) {
  }

  InitUserOptions() {
    this.UserOptions = [];

    this.IsBusy = true;

    let disposable = this.api.AdminsByPermissionType(AdminPermissionTypes.AppearInTicketingDropdown).subscribe(response => {
        disposable.unsubscribe();

        response.Data = SortBot.SortAuto<AdminItemArray>(response.Data, 'FirstName');

        this.IsBusy = false;
        
        response.Data.forEach(admin => {
            this.UserOptions.push({ label: admin.FirstName + ' ' + admin.LastName, value: admin.AdminID });
        });
    });

    // this.gb.AllAdmins.forEach(x => {
    //   if (x.AdminID == this.gb.AdminId || x.FirstName == 'API')
    //     return;
    //   this.UserOptions.push({ label: x.FirstName + ' ' + x.LastName, value: x.AdminID });
    // });

    this.UserOptions.sort((left, right) => {
      if (left.label > right.label) {
        return 1;
      } else {
        return -1;
      }
    });

    this.UserOptions.unshift({ label: 'Me - ' + this.gb.FullName, value: this.gb.AdminId });
    this.UserOptions.unshift({ label: 'Don\'t Assign', value: 0 });

    this.SelectedUser = this.gb.AdminId;
    this.notificationEmail = this.gb.Email;
  }

  InitStatusOptions() {

    this.StatusOptions = [];

    this.StatusOptions.push({ label: 'New', value: TicketStatusTypes.New });
    this.StatusOptions.push({ label: 'In Progress', value: TicketStatusTypes.InProgress });

    this.StatusOptions.push({ label: 'Awaiting Member', value: TicketStatusTypes.AwaitingMemberResponse });
    this.StatusOptions.push({ label: 'Awaiting Admin', value: TicketStatusTypes.AwaitingAdminResponse });
    this.StatusOptions.push({ label: 'TOS', value: TicketStatusTypes.TOS });

    this.StatusOptions.push({ label: 'Closed', value: TicketStatusTypes.Closed });

  }



  MemberSelectChanged() {
    if (this.SelectedMemberID == -1)
      this.SendEmail = false;
  }

  InitUrgencyOptions() {
    this.UrgencyOptions = [];
    this.UrgencyOptions.push({ label: 'Low', value: TicketUrgencyTypes.Low });
    this.UrgencyOptions.push({ label: 'Normal', value: TicketUrgencyTypes.Normal });
    this.UrgencyOptions.push({ label: 'High', value: TicketUrgencyTypes.High });
    this.UrgencyOptions.push({ label: 'Super High', value: TicketUrgencyTypes.SuperHigh });
  }

  UrgencyChanged() {
  }

  AdminChanged(index: number) {
    this.notificationEmail = this.gb.AllAdmins[index - 1].Email;
  }


  async showSelectEmailTemplate(e: any) {
    this.IsBusy = true;

    if (this.SelectedMemberID != 0) {

      await this.api.getMemberDashboard(this.SelectedMemberID).toPromise().then(response => {
        this.MemberData = response.Data;
      }, error => { });

    }


    if (this.isTemplatesEmpty()) {
      let response = await this.api.GetEmailTemplatesBasicsAndFrom().toPromise();
      if (response.Result) {
        this.TemplatesAndFrom = response.Data;
      } else { }
    }

    this.IsBusy = false;

    this.emailTemplatePanel = true;
    this.cdRef.detectChanges();
  }

  isTemplatesEmpty(): boolean {
    if (this.TemplatesAndFrom == null || this.TemplatesAndFrom == undefined)
      return true;
    else if (this.TemplatesAndFrom.Templates == null || this.TemplatesAndFrom.Templates == undefined || this.TemplatesAndFrom.Templates.length == 0)
      return true;
    else
      return false;
  }


  updateEmailTemplate(newTemplate: string) {
    this.emailTemplate = newTemplate;
    this.Body = this.emailTemplate;
    this.emailTemplatePanel = false;
  }

  updateEmailAddress(newEmailAddress: string) {
    // this.emailTo = newEmailAddress;
  }

  updateSubject(newSubject: string) {
    this.Subject = newSubject;
  }


  Close() {
    // this.InvokeEvent(WindowEvent.FromWindowContextResultOK(this.Context, WindowActionTypes.Saved, true));
    // window.close();
    this.close()
  }

}
